<script setup>
import { computed } from 'vue'
import Icon from '@shared/icons/Icon.vue'
import LoadingDots from '@shared/loading/LoadingDots.vue'
import { buttonIconSizes, buttonSizes, circleButtonIconSizes, circleButtonSizes } from '@/config'

const props = defineProps({
  as: {
    type: String,
    default: 'button',
  },
  type: {
    type: String,
    default: 'default', // options: default, circle
  },
  size: {
    type: String,
    default: 'md',
  },
  icon: {
    type: String,
    default: '',
  },
  iconClass: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  submittingText: {
    type: String,
    default: 'Submitting',
  },
})

const sizeClasses = computed(() => (props.type === 'circle') ? circleButtonSizes[props.size] : buttonSizes[props.size])
const iconSizeClasses = computed(() => (props.type === 'circle') ? circleButtonIconSizes[props.size] : buttonIconSizes[props.size])
</script>

<template>
  <button
    :type="as"
    :class="[sizeClasses, isSubmitting ? 'tw-pointer-events-none' : '']"
    :disabled="isDisabled"
    class="tw-inline-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-full tw-border tw-border-gray-2-200 tw-bg-white tw-font-medium tw-text-primary-200 hover:tw-border-gray-2-200 hover:tw-bg-white hover:tw-text-secondary-100 hover:tw-shadow-md hover:tw-ease-in-out focus:tw-border-accent-300 focus:tw-text-secondary-100 disabled:tw-pointer-events-none disabled:tw-border-gray-300 disabled:tw-text-gray-400 active:tw-bg-white active:tw-border-gray-2-200 active:tw-text-primary-200"
  >
    <template v-if="icon">
      <Icon :icon="icon" :class="[iconSizeClasses, iconClass]" />
    </template>

    <template v-if="isSubmitting">
      <span v-text="submittingText" />
      <LoadingDots color="tw-bg-primary-200" size="sm" />
    </template>
    <template v-else>
      <slot />
    </template>
  </button>
</template>
